import { render, staticRenderFns } from "./FichasMMA2.vue?vue&type=template&id=25858b70&"
import script from "./FichasMMA2.vue?vue&type=script&lang=js&"
export * from "./FichasMMA2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports